import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import Moment from 'moment';
import { connect } from 'react-redux';
import { loadCompliance } from '../../redux/actions/complianceActions';

class RenderRow extends Component {
  state = {
    expanded: false,
    assignee: null,
    status: null,
    dueDate: null,
    controls: null,
    open: false
  }

  componentDidMount () {
    const { state } = this.props.control;
    return state ?
      this.setState({
        assignee: state.assignee,
        status: state.status,
        dueDate: state.dueDate
      }) : this.setState({ assignee: 1, dueDate: Moment(), status: this.props.defaultValue });
		}

  render () {
    const { control } = this.props;

    return (
      <tr className="control-row">
        <td>
          {control.question}
        </td>
        <td>
								{renderResponseIcon(control.status)}
        </td>
								<td>
								{control.comment}
        </td>
      </tr >
    )
  }
}


function mapStateToProps (state) {
  return {
    theme: state.theme,
    activities: state.profileActivity.activities
  }
}

function renderResponseIcon (status) {
			let icon = '';
			if(status === 'Yes'){
					icon = '✅';
			}else if(status === 'No'){
					icon = '❌';
			}else {
					icon = '';
			}

			return icon;
}

export default connect(mapStateToProps, { loadCompliance })(reduxForm({
  form: 'render-row'
})(RenderRow))



// WEBPACK FOOTER //
// ./src/components/vendor_assessments/renderRow.js